export default "__VITE_ASSET__CLoGUMx0__"